'use memo'

import { capitalizeWords } from '@sportninja/common/ts-utils'
import type { PluginKey } from '@sportninja/common/features/account/apiAccess'
import { SelectInput } from 'src/components/ts-components/SelectInput'

interface PluginKeySelectProps {
  /** The selected key. */
  pluginKey: PluginKey
  pluginKeys: PluginKey[]
  onKeyChange: (keyId: string | null) => void
}

/** The key the preview and the embed code both use. */
export const PluginKeySelect = ({
  pluginKey,
  pluginKeys,
  onKeyChange,
}: PluginKeySelectProps) => (
  <SelectInput
    name='pluginKey'
    label={capitalizeWords('Key')}
    placeholder={capitalizeWords('Key')}
    options={pluginKeys.map(({ id, name, environment }) => ({
      label: `${name} (${capitalizeWords(environment)})`,
      value: id,
    }))}
    value={pluginKey.id}
    onChange={(value) => onKeyChange(value ?? null)}
    fieldErrors={{}}
    customError={{}}
    disabled={pluginKeys.length < 2}
  />
)
